<template>
  <i-input ref="input" v-on="$listeners" />
</template>

<script>
  /**
   * TODO :: Используется в паре мест, подумать, может выпилить этот компонент
   */
  export default {
    props: {
      value: {
        type: [String, Number],
        default: ''
      }
    },

    watch: {
      value: {
        handler: function(e) {
          this.replace(e);
        },
        immediate: true
      }
    },

    methods: {
      replace(e) {
        this.$nextTick(() => {
          const value = e.replace(/[^\d]+/g, '');
          this.$refs.input.setCurrentValue(value);
          if (this.value !== value) {
            this.$emit('input', value);
          }
        });
      }
    }
  };
</script>
